import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { challengeService } from '@/services/challenge';

export function useChallengeList() {
    const { list, total, fetchList } = useBaseListView({ request: challengeService.list });
    const { confirmAndRemove, confirmAndEnable, confirmAndDisable } = useCrudActions();

    const actions = {
        remove: confirmAndRemove({ request: challengeService.remove, onSuccess: () => fetchList() }),
        enable: confirmAndEnable({ request: challengeService.enable, onSuccess: () => fetchList() }),
        disable: confirmAndDisable({ request: challengeService.disable, onSuccess: () => fetchList() })
    };

    return { list, total, fetchList, actions };
}
